import type { PropsWithChildren } from 'react'

import clsx from 'clsx'
import { SupportButton } from 'components/atoms/SupportButton/SupportButton.js'
import { CONSTS } from 'config/objectConst.js'
import { useLocation } from 'react-router-dom'
// @ts-ignore
import { Element } from 'react-scroll'
import { useDocumentTitle } from 'shared/hooks'

import LeftSideMenu from '../../molecules/leftSideMenu/index.js'
import { Header } from '../../organisms/Header/index'
import css from './HomeTemplate.module.scss'

export function HomeTemplate({
	children,
	id = 'homeTemplateContainerID'
}: PropsWithChildren<{
	id?: string
}>) {
	const location = useLocation()
	useDocumentTitle(CONSTS.PROJECT_NAME)
	return (
		<div className={clsx(css.root, 'wrapper')}>
			<Header className={css.header} />

			<LeftSideMenu className={css.side} />
			<Element
				className={clsx(
					css.main,
					'app-scroll',
					location?.pathname.includes('activities-queue') ||
						location?.pathname.includes('team')
						? 'container'
						: 'containerAccent'
				)}
				id={id}
				name='container'
			>
				{children}
			</Element>
			<SupportButton />
		</div>
	)
}
